import { computed, defineComponent, type FunctionalComponent, unref } from 'vue'
import type { FormLayoutProps } from '../types/form'
import type { UseFormReturn } from '../formv2/hooks/useForm'
import { useFormFieldRender } from '../render'
import HeaderSm from 'components/headers/sm'

export const FormLayout = defineComponent<{
  layout: FormLayoutProps<any>,
  handler: UseFormReturn,
  depth?: number;
}>(
  (props) => {
    const layout = computed(() => unref(props.layout));
    const field = computed(() => {
      return layout.value.$field ? props.handler.selectField(layout.value.$field) : null
    })
    const key = computed(() => field.value ? (field.value.value.key || field.value.value.name) + '' : '?')

    const renderer = useFormFieldRender({
      handler: props.handler,
      schema: {}
    });

    const DefaultWrapper: FunctionalComponent<any> = ((props: any, ctx) => <div class={props.class || ''} style={props.style || {}} key={props.key}>{ctx.slots.default ? ctx.slots.default() : ''}</div>);
      const Wrapper = (layout.value.$component ? layout.value.$component : DefaultWrapper) as FunctionalComponent<any>;
      const outer = layout.value.$outerWrapper;

    return () => {


      return (
        <Wrapper class={[outer?.$class || '']} style={[outer?.$style || {}]}>
          {layout.value.$label && <div>{layout.value.$label}</div>}
          {layout.value.$header && layout.value.$header.$title ? <HeaderSm title={layout.value.$header.$title} subtitle={layout.value.$header.$subtitle}/> : null}
          <div class={[layout.value.$class || '']} style={[layout.value.$style || {}]}>
              {field.value ? renderer.renderField(key.value, field.value) : null}

            {(unref(layout.value.$children) || []).map((child) => (
              <FormLayout depth={(props.depth || 0) + 1} layout={child} handler={props.handler} />
            ))}
          </div>
        </Wrapper>
      )
    }
  },
  { props: ['layout', 'handler', 'depth'] }
)
